<template>
	<v-container class="my-9">
		<v-row class="mb-4">
			<v-col cols md="12">
				<h2 class="display-2 mt-4">Reto de Altares</h2>
				<v-divider class="dorado mt-4" />
			</v-col>
			<v-col md="12">
				<v-alert
					color="rojo"
					dark
					icon="mdi-vote"
					border="left"
					class="text-h5 white--text"
					prominent>
					<strong>
						Recuerda que solo puedes emitir un voto por cada categoría.
					</strong>
				</v-alert>
			</v-col>
		</v-row>

		<v-row class="d-flex justify-space-around">
			<v-col md="5" class="text-center">
				<a
					href="/vinculacion/concursos/altares/rme"
					class="text-decoration-none">
					<h2
						class="text-h4 verde blue-grey--text text--lighten-5 rounded py-9">
						<v-icon size="96" class="white--text mb-4">mdi-town-hall</v-icon
						><br />
						Representaciones<br />
						de <strong>México</strong>
					</h2>
				</a>
			</v-col>
			<v-col md="5" class="text-center">
				<a
					href="/vinculacion/concursos/altares/comunidades"
					class="text-decoration-none">
					<h2
						class="text-h4 dorado blue-grey--text text--lighten-5 rounded py-9">
						<v-icon size="96" class="white--text mb-4">mdi-hand-heart</v-icon
						><br />
						Comunidades <br />
						<strong>Mexicanas</strong>
					</h2>
				</a>
			</v-col>
		</v-row>

		<v-row v-if="!auth_status.loggedIn">
			<v-col class="text-center mt-8">
				<h3 class="text-h4">Registrate para participar</h3>
				<v-btn
					dark
					rounded
					x-large
					color="dorado"
					class="my-4 mx-2"
					to="/auth/register">
					<v-icon left>mdi-import</v-icon>
					Registrarme
				</v-btn>
				<v-btn
					dark
					rounded
					x-large
					color="dorado"
					class="my-4 mx-2"
					to="/auth/login">
					<v-icon left>mdi-account</v-icon>
					Iniciar sesion
				</v-btn>
			</v-col>
		</v-row>

		<v-row v-else>
			<v-col class="text-center mt-8">
				<h3 class="text-h4">
					Has ingresado con el correo: <br />
					<strong>{{ auth_user.email }}</strong>
				</h3>
				<v-btn
					dark
					rounded
					x-large
					color="dorado"
					class="my-8 mx-2"
					@click="logOut">
					Cerrar sesion
				</v-btn>
			</v-col>
		</v-row>

		<!-- <v-row>
			<v-col>
				<pre>{{ auth_user }}</pre>
			</v-col>
		</v-row> -->
	</v-container>
</template>

<script>
	import UserService from "@/services/user.service";

	export default {
		name: "AltaresIndexView",

		components: {},

		data: () => ({
			user_me: {
				role: {},
			},
			path: {
				base_url: process.env.VUE_APP_BASE_URL,
				endpoint: process.env.VUE_APP_ENDPOINT,
				storage_files: process.env.VUE_APP_STORAGE_FILES,
			},
		}),

		computed: {
			auth_status() {
				return this.$store.state.auth.status;
			},
			auth_user() {
				let data_user = this.$store.state.auth.user.user;
				//console.log("🚀 ~ auth_user ~ data_user:", data_user.id);
				return data_user;
			},
		},

		mounted() {
			//this.auth_user;
			// this.currentUser.user.id;

			if (this.$store.state.auth.user) {
				UserService.loadMe(this.auth_user.id).then((response) => {
					this.user_me = response.data;
					//console.log("🚀 ~ UserService ~ this.user_me:", this.user_me);
				});
			}
		},

		methods: {
			logOut() {
				this.$store.dispatch("auth/logout");
				this.$router.go(0);
				//this.$router.push("/auth/login");
				//localStorage.removeItem("organization_type");
			},
		},
	};
</script>
